export default __webpack_public_path__ + "static/media/expl_gradcam_03_DE.b1de676c.png";